export const services = [
  {
    image: require("./assets/images/family.png"),
    Title: "Divorce & Family Law",
    desc: "We take extreme care to ensure that you get through your divorce in the best possible way.",
  },
  {
    image: require("./assets/images/broken-arm.png"),
    Title: "Personal Injury",
    desc: "Taking the Legal Route After An Injury.",
  },
  {
    image: require("./assets/images/bankruptcy.png"),
    Title: "Bankruptcy",
    desc: "Our bankruptcy attorneys at NYC are here to help you with any of your debt, insolvency, and bankruptcy issues.",
  },
  {
    image: require("./assets/images/law.png"),
    Title: "Wage & Hour",
    desc: "Our lawyers strive to make sure that employees are rightfully paid.",
  },
  {
    image: require("./assets/images/handcuffs.png"),
    Title: "Criminal Law",
    desc: "The firm has a distinguished record in Handling Criminal Cases, especially involving immigration.",
  },
  {
    image: require("./assets/images/lgbt.png"),
    Title: "LGBTQ",
    desc: "We handle cases that will have the greatest impact on recognizing, protecting and advancing the rights of LGBTQ people.",
  },
];

